const DEFAULT_COUNTRY = 'Australia';

export const toManualAddress = (fullAddress, currentAddress) => ({
  fullAddress,
  country: currentAddress?.country ?? DEFAULT_COUNTRY,
});

export const getModeChangeAddress = (isCustomAddress, currentAddress) => (
  isCustomAddress ? toManualAddress(currentAddress?.fullAddress ?? '', currentAddress) : null
);

export const getAddressSearchError = ({ address, isCustomAddress, searchString, isValidationActive, requiredMessage }) => {
  if (!!address?.fullAddress || !isValidationActive) return null;
  if (isCustomAddress || !searchString) return requiredMessage;
  if (searchString.length < 3) return 'Must be at least 3 characters';
  if (searchString.length > 500) return 'You have exceeded the maximum number of 500 characters';
  return requiredMessage;
};
